// = Libs =
import { FC } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

// = Styles =
import classes from './back-button.module.scss';

// = Types =
import { BackButtonProps } from './back-button.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

const BackButton: FC<BackButtonProps> = (props) => {
  const { previousPage, previousPath = '/', lightMode = false } = props;

  return (
    <Link className={classes.button} to={previousPath}>
      <span className={classes.button__icon}>
        <Icon type="arrow-left" />
      </span>
      {previousPage && (
        <span
          className={clsx({
            [classes['button__text']]: true,
            [classes['button__text--light']]: lightMode,
          })}>
          {previousPage}
        </span>
      )}
    </Link>
  );
};

export default BackButton;
